import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import {Row, Col} from 'react-flexbox-grid/lib';
import { connect } from 'react-redux';
import ReactHighcharts  from 'react-highcharts';
import {Card, CardHeader, CardMedia} from 'material-ui/Card';

import styles from './styles/ChartsDataStyles';
import SpinnerLoaderWithText from 'components/loaders/SpinnerLoaderWithText';
import NotAvailable from 'components/notAvailable/NotAvailable';
import {convertMiPerHourToKmPerHour} from 'services/systemOfUnitsServices';

class ChartsData extends React.Component {
    constructor(props){
        super(props);

        this.getAccelerationChartConfig = this.getAccelerationChartConfig.bind(this);
        this.getSpeedChartConfig = this.getSpeedChartConfig.bind(this);
        this.getAccelerationChartSeries = this.getAccelerationChartSeries.bind(this);
        this.getSpeedChartSeries = this.getSpeedChartSeries.bind(this);
    }

    getAccelerationChartSeries(){
        if(!this.props.accelerationList) return null;
        if(this.props.accelerationList.length <= 0) return null;
        var {translate} = this.props;

        var accelerationList = this.props.accelerationList.sort(function(a,b)
        {
           if(a.time < b.time) return -1;
           if(a.time > b.time) return 1;
           return -1;
        });

        var xseries = [];
        var yseries = [];
        var zseries = [];

        var substract = null;

        if (accelerationList.length > 1) {
            /*
                devo far in modo di avere come primo punto il tempo 0
                quindi devo sottrarre a tutti gli elementi il tempo alla posizione 0
                ma solo se è > 0!
            */
            if (accelerationList[0].time > 0) {
                substract = accelerationList[0].time;
            }
        }

        for(var i=0;i<accelerationList.length;i++){
            var item = accelerationList[i];

            var timeZero = (item.time - substract).toFixed(3);
            var datax = [timeZero.toString(), item.accX];
            var datay = [timeZero.toString(), item.accY];
            var dataz = [timeZero.toString(), item.accZ];

            xseries.push(datax);
            yseries.push(datay);
            zseries.push(dataz);
        }

        var series =
            [
                {
                    data: xseries,
                    name: translate('ChartsForm.xacceleration'),
                    color: '#69B246'
                },
                {

                    data: yseries,
                    name: translate('ChartsForm.yacceleration'),
                    color: '#41C0D7'
                },
                {

                    data: zseries,
                    name: translate('ChartsForm.zacceleration'),
                    color: '#7F4467'
                }
            ]

        return series;
    }

    getAccelerationChartConfig(){
        var {translate} = this.props;

        var config = {
            series: this.getAccelerationChartSeries(),
            legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
            },
            chart: {
                backgroundColor: null,
                style: {
                   fontFamily: "'Source Sans Pro', 'Calibri Light', 'Roboto'"
                }
             },
            title: {
                text: null
            },
            yAxis: {
                title: {
                    text: translate('ChartsForm.acceleration') + " (g)"
                }
            },
            xAxis: {
                type: 'category',
                title: {
                    text: translate('ChartsForm.time') + " (s)"
                }
            },
            tooltip: {
                formatter: function() {
                    return '<b>'+ this.series.name +'</b><br/>'+
                        this.y +' (g)<br/>'+
                        this.point.name + ' (s)';
                },
                shared: false
            }
          };

        return config;
    }

    getSpeedChartSeries(){
        if(!this.props.speedList) return null;
        if(this.props.speedList.length <= 0) return null;
        var {translate, isMilesPerHour} = this.props;

        var speedList = this.props.speedList.sort(function(a,b)
        {
           if(a.time < b.time) return -1;
           if(a.time > b.time) return 1;
           return -1;
        });

        var series = [];

        for(var i=0;i<speedList.length;i++){
            var item = speedList[i];

            var speed = item.speed;
            if(!isMilesPerHour)
            {
                speed = parseFloat(convertMiPerHourToKmPerHour(item.speed));
            }

            var data = [item.time, speed];
            series.push(data);
        }

        var seriesData =
            [
                {
                    data: series,
                    name: translate('ChartsForm.velocityDiagram'),
                    color: '#69B246'
                }
            ]

        return seriesData;
    }

    getSpeedChartConfig(){
        var {translate, isMilesPerHour} = this.props;

        var unitOfMeaserLabel = translate('GLOBAL.kmph');
        if (isMilesPerHour) {
            unitOfMeaserLabel = translate('GLOBAL.miph');
        }

        var config = {
            series: this.getSpeedChartSeries(),
            legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
            },
            chart: {
                style: {
                   fontFamily: "'Source Sans Pro', 'Calibri Light', 'Roboto'"
                }
             },
            title: {
                text: null
            },
            yAxis: {
                title: {
                    text: translate('ChartsForm.speed') + ' ' + unitOfMeaserLabel
                }
            },
            xAxis: {
                type: 'category',
                title: {
                    text: translate('ChartsForm.time') + " (s)"
                }
            },
            tooltip: {
                formatter: function() {
                    return '<b>'+ this.series.name +'</b><br/>'+
                        this.y +' (' + unitOfMeaserLabel + ')<br/>'+
                        this.x + ' (s)';
                },
                shared: false
            }
          };
        return config;
    }

    render() {

        console.info("charts data rendered");

        var accelerationConfig = this.getAccelerationChartConfig();
        var speedConfig = this.getSpeedChartConfig();

        const {translate, isSpeedListSearching, speedList, isAccelerationListSearching, accelerationList } = this.props;

        return (
            <div style={styles.mainDataRow}>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={6} >
                        <Card initiallyExpanded={true}>
                            <CardHeader
                                title={translate('ChartsForm.accelerationDiagram')}
                            />
                            <CardMedia>
                                {
                                    isAccelerationListSearching ? <SpinnerLoaderWithText />
                                    :
                                    accelerationList && accelerationList.length > 0 ?
                                        <ReactHighcharts config = {accelerationConfig}></ReactHighcharts>
                                        : <NotAvailable />
                                }
                            </CardMedia>
                        </Card>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} >
                        <Card initiallyExpanded={true}>
                            <CardHeader
                                title={translate('ChartsForm.velocityDiagram')}
                            />
                            <CardMedia>
                                {
                                    isSpeedListSearching ? <SpinnerLoaderWithText />
                                    :
                                    speedList && speedList.length > 0 ?
                                        <ReactHighcharts config = {speedConfig}></ReactHighcharts>
                                        : <NotAvailable />
                                }
                            </CardMedia>
                        </Card>
                    </Col>
                </Row>

            </div>
        );
    }
}

ChartsData.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){

    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        speedList: state.icnSpeed.list,
        isSpeedListSearching: state.icnSpeed.isSearching,
        accelerationList: state.icnAcceleration.list,
        isAccelerationListSearching: state.icnAcceleration.isSearching,
        isMilesPerHour: state.systemUnitsSearch.item ? state.systemUnitsSearch.item.isMilesPerHour : false,
        speedUnitOfMeasure: state.systemUnitsSearch.item ? state.systemUnitsSearch.item.speedUnitOfMeasure : null
    }
}

export default connect(mapStateToProps, null)(ChartsData);


// WEBPACK FOOTER //
// ./src/components/detailsPage/ChartsData.js